const BLOGS_BLOCK_DATA = {
  description: '',
  descriptionMobile: '',
  article1Id: null,
  article2Id: null,
  article3Id: null,
  withBottomSection: true,
  leftImage: '',
  leftImageMobile: '',
  rightImage: '',
  rightImageMobile: '',
  leftButtonText: 'Learn More @ Vintage University',
  leftButtonTextMobile: 'More @ Vintage University',
  leftButtonLink: 'https://foreverstudios.com/blog',
  rightButtonText: 'Take Our Guided Tour of FS HQ',
  rightButtonTextMobile: 'Take Our Tour of FS HQ',
  rightButtonLink: 'https://foreverstudios.com/visit-forever-studios-headquarters-virtual-experience/',
};

export default BLOGS_BLOCK_DATA;
